<div class="wrapper page-heading page-heading-header-bg">
    <form [formGroup]="searchForm">
        <div class="row page-heading-left">
            <div class="col-xs-6">
                <h1 [i18n]="'df-management.title'"></h1>
            </div>
            <div>
                <img src="assets/NotificationWhite.svg"
                            class="bellIconAlerts" alt="bellIcon" (click)="openPopup()">
                <app-notification-alert *ngIf="isPopupVisible | async" [countryCode]="countryCode"></app-notification-alert>
            </div>
            <div class="col-xs-6">
                <div class="row">
                    <div class="col-xs-5">
                        <ng-select 
                        placeholder={{selectCountry}}
                         formControlName="country"
                            (change)="updateCountry($event)">
                            <ng-option *ngFor="let column of countryData" [value]="column">
                                {{column.country}}
                            </ng-option>
                        </ng-select>
                    </div>
                    <div class="col-xs-7">
                        <ng-select placeholder={{selectCarrierID}} formControlName="carrierId" [searchable]="true"
                            [multiple]="true" bindLabel="carrier" (change)="updateCarrierId($event)"
                            groupBy="selectedAllGroup" [selectableGroup]="true" [selectableGroupAsModel]="false"
                            [closeOnSelect]="false">
                            <ng-option *ngFor="let column of carriers" [value]="column">
                                {{column.carrier}} - {{column.carrier_code}}
                            </ng-option>
                            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                                <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}"/>
                                Select All
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
                                    [ngModelOptions]="{standalone: true}" />
                                {{item.carrier}} - {{item.carrier_code}}
                            </ng-template>
                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                <div class="ng-value" *ngFor="let item of items | slice: 0:1">
                                    <span class="ng-value-label">{{ item.carrier }}</span>
                                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                </div>
                                <div class="ng-value" *ngIf="items.length > 1">
                                    <span class="ng-value-label">{{ items.length - 1 }} more...</span>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
<section class="chepfm--section__filters conta">
    <div class="container">
        <form class="chepfm--filter__form" [formGroup]="searchForm">
            <div class="row">
                <div class="col-lg-4 col-sm-4">
                    <div class="data-filter">
                        <label [i18n]="'df-management.filters.labels.search'"></label>
                        <div class="input-group">
                            <span class="input-group-text"><i class="fa fa-search"></i></span>
                            <input class="form-control" 
                            [i18n]="[{target: 'attribute:placeholder', key: 'df-management.filters.placeholder.search-for-result'}]"
                            [(ngModel)]="searchText"  [ngModelOptions]="{standalone: true}">
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-sm-4">
                    <div class="data-filter">
                        <label [i18n]="'df-management.filters.labels.asset-id'"></label>
                        <ng-select 
                        placeholder={{selectAssetID}}
                        (change)="updateAsset($event)"
                        formControlName="assetId">
                        <ng-option *ngFor="let column of assets" [value]="column">
                            {{column.asset_id}}
                        </ng-option>
                        </ng-select>
                    </div>
                </div>
                <div class="col-lg-4 col-sm-4">
                    <div class="chepfm--filter__actions">
                        <i class="fa fa-ban repeat--icon" aria-hidden="true" ></i>&nbsp;&nbsp;
                        <a class="chepfm--link" (click)="resetSearchData()">
                            <span [i18n]="'df-management.filters.buttons.reset-button'"></span>
                        </a>
                        <button class="btn btn-i info" type="submit" [disabled]="isFetchButtonDisabled" (click)="applyForm('blueYounder')">
                            <span  [i18n]="'df-management.filters.buttons.fetch-from-by'"></span>
                        </button>&nbsp;&nbsp;
                        <button class="btn btn-i btn-primary" type="submit" [disabled]="isFetchButtonDisabled" (click)="applyForm('fleetManagement')">
                            <span  [i18n]="'df-management.filters.buttons.apply-button'"></span>
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</section>
<section class="chepfm--section__filters">
   <div class="container">
    <div class="col-md-auto pull-right">
        <div class="chepfm--filter__actions">
            <app-df-master-file-upload [labelKey]="'df-management.form.file.file-upload'"
            [acceptedFileExtensions]="acceptedFileExtensions" [disabled]="isButtonDisabled"
            (onFileAdded)="uploadMasterDataFile($event)" class="btn btn-i">
            </app-df-master-file-upload>&nbsp;
            <button type="submit" class=" btn btn-i download-btn" [disabled]="isButtonDisabled" (click)="downloadMasterData()">
                <i class="fa fa-download" aria-hidden="true">&nbsp;</i><span  [i18n]="'df-management.form.file.download-master-template'"></span>
           </button>
        </div>
    </div>
   </div>
</section>
<section class="container summary-panel">
        <app-data-table [columns]="columns"
         [sortColumn]="sortColumn" 
         [loadPage]="loadPage" 
         [(filters)]="filters" 
         [showColumnsSelection]="false"
         (onLoad)="getMasterData()">
</app-data-table>
    <ng-template #carrierCodeColumn let-carrierCode="carrierCode">
        <span class="rowName" >{{ carrierCode }}</span>
    </ng-template>
    <ng-template #assetIdColumn let-assetId="assetId">
        <span class="rowName">{{ assetId }}</span>
    </ng-template>
    <ng-template #equipmentTypeColumn let-assetType="assetType">
        <span class="rowName">{{ assetType }}</span>
    </ng-template>
    <ng-template #contractStartDateColumn let-contractStartDate="contractStartDate">
        <span class="rowName">{{( contractStartDate | date:'yyyy-MM-dd':'UTC') }}</span>
    </ng-template>
    <ng-template #contractEndDateColumn let-contractEndDate="contractEndDate">
        <span class="rowName">{{ (contractEndDate | date:'yyyy-MM-dd':'UTC')}}</span>
    </ng-template>
    <ng-template #dfDistanceColumn let-distanceTravel="distanceTravel">
        <span class="rowName">{{ distanceTravel }}</span>
    </ng-template>
    <ng-template #rentChargesColumn let-rentCharges="rentCharges">
        <span class="rowName">{{ rentCharges }}</span>
    </ng-template>
    <ng-template #actionsColumn let-item="item">
        <div class="chepfm-table__actions" >
            <button type="button" class="btn btn-info btn-sm" [disabled]="isEditButtonDisabled" (click)="onEditClick(item)">
                <i class="fa fa-caret-right vert-align-top" aria-hidden="true"></i></button>
        </div>
    </ng-template>
</section>
<div class="overlay-form" *ngIf="isVisible">
<div class="chepfm--form__collapse-wrapper"
    [ngClass]="isVisible ? 'chepfm--form__collapse-show' : 'chepfm--form__collapse-hide'">
    <div class="chepfm--form__collapse-header">
        <h6 class="chepfm--form__collapse-heading" [i18n]="'df-management.update-title'"></h6>
        <div class="close-icon">
            <button type="button" class="btn btn-link" (click)="onCloseClick()">
                <span _ngcontent-owx-c9="" class="fa fa-close"></span>
            </button>
        </div>
    </div>
    <div class="chepfm--form__collapse-contain">
        <form class="chepfm--form" [formGroup]="dedicatedFleetMasterDataForm">
            <div class="row">
                <div class="col-xs-6">
                    <div class="data-filter">
                        <label [i18n]="'df-management.form.name.carrier-id'"></label>
                        <input type="text" class="form-control" [attr.disabled]="true" formControlName="carrierId"
                        [i18n]="[{target: 'attribute:placeholder', key: 'df-management.form.name.carrier-id'}]">
                    </div>
                </div>
                <div class="col-xs-6">
                    <div class="data-filter">
                        <label [i18n]="'df-management.form.name.asset-id'"></label>
                        <input type="text" class="form-control" [attr.disabled]="true" formControlName="assetId"
                        [i18n]="[{target: 'attribute:placeholder', key: 'df-management.form.name.asset-id'}]"
                        >
                    </div>
                </div>
                <div class="col-xs-6">
                    <div class="data-filter">
                        <label [i18n]="'df-management.form.name.contract-start-date'"></label>
                        <input class="form-control" [dpDayPicker]="config" [theme]="'date-time-picker'"
                            formControlName="contractStartDate" 
                            [i18n]="[{target: 'attribute:placeholder', key: 'df-management.filters.placeholder.select-date'}]" 
                            [readonly]="validate.contractStartDate" >
                        <span *ngIf="dateErrorMsg" class="date-picker-errormsg">
                            <span  [i18n]="'df-management.form.message.start-date-message'"></span>
                        </span>
                    </div>
                </div>
                <div class="col-xs-6">
                    <div class="data-filter">
                        <label  [i18n]="'df-management.form.name.contract-end-date'"></label>
                        <input class="form-control" [dpDayPicker]="config" [theme]="'date-time-picker'"
                            formControlName="contractEndDate" [readonly]="validate.contractEndDate"
                            [i18n]="[{target: 'attribute:placeholder', key: 'df-management.filters.placeholder.select-date'}]">
                        <span *ngIf="dateErrorMsg" class="date-picker-errormsg">
                            <span  [i18n]="'df-management.form.message.end-date-message'"></span>
                        </span>
                    </div>
                </div>
                <div class="col-xs-6">
                    <div class="data-filter field-space">
                        <label [i18n]="'df-management.form.name.df-distance'"></label>
                        <input type="text" class="form-control" formControlName="dfDistance" [readonly]="validate.dfDistance"
                        [i18n]="[{target: 'attribute:placeholder', key: 'df-management.form.name.df-distance'}]" validateNumber="15">
                        <span class="errormsg"  *ngIf="(dedicatedFleetMasterDataForm.get('dfDistance').touched || dedicatedFleetMasterDataForm.get('dfDistance').dirty) && dedicatedFleetMasterDataForm.get('dfDistance').errors">
                            <span [i18n]="'df-management.form.message.dfdistance-error-message'"></span>
                        </span>
                    </div>
                </div>
            </div>
            <h5 class="chepfm--form__collapse-heading" [i18n]="'df-management.form.name.charge-type'"></h5>
            <hr />
            <div class="row">
                <div class="col-xs-6">
                    <div class="chepfm-header">
                        <h4 class="chepfm--form__collapse-heading"  [i18n]="'df-management.form.name.fixed-charges'"></h4>
                        &nbsp;<span class="chepfm-asterisk">(Mandatory)</span>
                    </div>
                    <div class="data-filter">
                        <label [i18n]="'df-management.form.name.contracted-truck-rent-charges'" *ngIf="fixedFrequencyCharge === 'Daily'"></label>
                        <label [i18n]="'df-management.df-transaction.form.form-headings.weekly-truck-rent'" *ngIf="fixedFrequencyCharge === 'Weekly'" ></label>
                        <label [i18n]="'df-management.df-transaction.form.form-headings.monthly-truck-rent'" *ngIf="fixedFrequencyCharge === 'Monthly'"></label>
                        <input type="text" class="form-control" validateNumber="9.3" [readonly]="validate.contractedTruckRentCharges"
                        [i18n]="[{target: 'attribute:placeholder', key: 'df-management.form.placeholder.placeholder-message'}]"
                        formControlName="contractedTruckRentCharges">
                        <span class="errormsg"  *ngIf="(dedicatedFleetMasterDataForm.get('contractedTruckRentCharges').touched || dedicatedFleetMasterDataForm.get('contractedTruckRentCharges').dirty) && dedicatedFleetMasterDataForm.get('contractedTruckRentCharges').errors">
                            <span [i18n]="'df-management.form.message.error-message'"></span>
                        </span>
                    </div>
                </div>
                <div class="col-xs-6" *ngIf="editMasterData.assetCharges?.length">
                    <div class="chepfm-header">
                        <h4 class="chepfm--form__collapse-heading"  [i18n]="'df-management.form.name.variable-charges'"></h4>
                        &nbsp;<span class="chepfm-asterisk">(Optional)</span>
                    </div>
                    <app-df-optional-charges [optionalAmountControls]="dedicatedFleetMasterDataForm?.get('amount')['controls']" 
                    [chargeCodeValidate]="validate"> 
                    </app-df-optional-charges>
               </div>
                </div>&nbsp;&nbsp;
            <div class="chepfm--form__actions">
                <button class="btn btn-i btn-primary" type="submit" appDebounceClick (debounceClick)="dfRemoveData()" [disabled]="(validate.removeBtn)|| editMasterData.id === null">
                    <span [i18n]="'df-management.form.buttons.remove'"></span>
               </button>&nbsp;&nbsp;
                <button class="btn btn-i btn-primary" type="submit" appDebounceClick (debounceClick)="dfMasterData()" [disabled]="(validate.submitBtn) || !(dedicatedFleetMasterDataForm.valid)">
                    <span [i18n]="'df-management.form.buttons.submit'"></span>
               </button>
            </div>
        </form>
    </div>
</div>
</div>
<div class="overlay" *ngIf="isPopupModel">
    <div class="popup">
        <i class="fa fa-check-circle success-button"></i>
        <h4 [i18n]="'df-management.form.model-popup.heading'"></h4>
      <div class="content" >
        <span [i18n]="'df-management.form.model-popup.content'"></span>
    </div>
    <div class="form-group ">
    <button class="btn btn-i btn-primary btn-lg button" type="submit" (click)="confirmData()">
        <span [i18n]="'df-management.form.model-popup.button'"></span>
    </button>
    </div>
    </div>
</div>

<div class="overlay" *ngIf="isPopupDownloadModel">
    <div class="popup">
        <i class="fa fa-check-circle down-load-success-button"></i>
        <h4 [i18n]="'df-management.form.file.success'"></h4>
      <div class="content" >
        <span [i18n]="'df-management.form.file.download-success-message'"></span>
    </div>
    <div class="form-group ">
    <button class="btn btn-i btn-primary btn-lg button" type="submit" (click)="confirmDownload()">
        <span [i18n]="'df-management.form.model-popup.button'"></span>
    </button>
    </div>
    </div>
</div>

<div class="overlay" *ngIf="isPopupErrorModel">
    <div class="popup">
        <span>
        <i class="fas fa-times-circle upload-error-button"></i>
       </span>
        <h4 [i18n]="'df-management.form.file.error'"></h4>
      <div class="content" >
        <span [i18n]="'df-management.form.file.erroe-message'"></span><br/>
        <span [i18n]="'df-management.form.file.error-message-content'"></span>
    </div>
    <div class="form-group ">
    <button class="btn btn-i btn-primary btn-lg button" type="submit" (click)="downloadButton()">
        <span [i18n]="'df-management.form.file.down-button'"></span>
    </button>
    </div>
    </div>
</div>

<div class="overlay" *ngIf="isDownReportSuccessPopupModel">
    <div class="sucesspopup">
        <i class="fa fa-check-circle download-success-button"></i>
        <h4 [i18n]="'df-management.form.file.success'"></h4>
        <div class="download-content">
            <span [i18n]="'df-management.form.file.download-report-success-message'"></span>
        </div>
        <div class="form-group">
            <button class="btn btn-i btn-primary btn-lg button" type="submit" (click)="confirmDownloadReportButton()">
                <span [i18n]="'df-management.form.model-popup.button'"></span>
            </button>
        </div>
    </div>
</div>
